import humanizeString from 'humanize-string';
import moment from 'moment';
import { metadataConfig, PREFERRED_ORDER } from '../constants/metadata';
import format from '../format';

export const sortMetadata = (metadataList) =>
  metadataList.sort((a, b) => {
    const indexA = PREFERRED_ORDER.indexOf(a.label);
    const indexB = PREFERRED_ORDER.indexOf(b.label);
    if (indexA === -1) {
      return 1;
    } else if (indexB === -1) {
      return -1;
    } else if (indexA < indexB) {
      return -1;
    } else {
      return 1;
    }
  });

export const displayMetadataValue = (value) => {
  const date = moment(
    value,
    ['YYYY:MM:DD HH:mm:ssZ', 'YYYY:MM:DD HH:mm:ss'],
    true,
  );
  if (date.isValid()) {
    return date.format(format.time_format);
  } else {
    return String(value);
  }
};

export const displayMetadataLabel = (value) => {
  const config = metadataConfig[value];

  if (config && config.title) {
    return config.title;
  }

  return humanizeString(value);
};

const truePredicate = () => true;
const identityTransform = (value) => value;

export const flattenMetadata = (
  metadata,
  predicate = truePredicate,
  transformKey = identityTransform,
) =>
  Object.entries(metadata || {}).reduce(
    (metadata, [type, metadataBlock]) =>
      Object.entries(metadataBlock || {}).reduce(
        (data, [key, value]) =>
          predicate(key, value, type)
            ? {
                ...data,
                [transformKey(key)]: [
                  ...(metadata[transformKey(key)] || []).filter(
                    (prevEntry) => prevEntry.value !== value,
                  ),
                  { value, type },
                ],
              }
            : data,
        metadata,
      ),
    {},
  );
